'use strict'

define ['./userDeleteModal.css'], () ->
  ($scope, $rootScope, $uibModalInstance, $cacheFactory, $http, RENTAPPLICATION_API_URL, Flash, $window) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    
    $scope.member_name = if $scope.current_membership?.name then $scope.current_membership.name else $scope.current_membership.user.username
    $scope.user_belongs_one_group = _.filter($scope.memberships, {'user' : $scope.current_membership.user}).length == 1

    $scope.remove_user = ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/company/#{$scope.current_membership.company.id}/remove_user/",
        user: $scope.current_membership.user.id
      .then (response) ->
        Flash.create('success',  $scope.member_name + ' removed.', 3000, {class: 'profile-success'}, true)
        $cacheFactory.get("$http").removeAll()
        $scope.load_companies()
      .catch ->
        Flash.create('danger', "there has been an error", 3000, { class: 'error' }, true)
      .finally ->
        $window.scrollTo(0, 0);
        $uibModalInstance.close()
      
    $scope.remove_membership = ->
      $http.delete "#{RENTAPPLICATION_API_URL}/api/v1/companymembership/#{$scope.current_membership.id}/"  
      .then (response) ->
        Flash.create('success',  $scope.member_name + ' removed.', 3000, {class: 'profile-success'}, true)
        $cacheFactory.get("$http").removeAll()
        $scope.load_companies()
      .catch ->
        Flash.create('danger', "there has been an error", 3000, { class: 'error' }, true)
      .finally ->
        $window.scrollTo(0, 0);
        $uibModalInstance.close()



// WEBPACK FOOTER //
// ./components/dashboard/settings/company/userDeleteModal/userDeleteModal.coffee